import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/home.vue'
import Category from '@/views/category/category.vue'
import Cart from '@/views/cart/cart.vue'
import Lista from '@/views/category/lista.vue'
import Pedidos from '@/views/pedidos/ultimos-pedidos.vue'
import Acessos from '@/views/acessos/usuarios.vue'
import Login from '@/views/login/login.vue'
// import Busca from '@/views/busca/busca.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        breadcrumb: 'Início'
      }
    },
    {
      path: '/categoria',
      name: 'categoria',
      component: Category,
    },
    {
      path: '/carrinho', 
      name: 'carrinho', 
      component: Cart
    },
    {
      path: '/lista/',
      name: 'lista',
      component: Lista
    },
    {
      path: '/ultimos-pedidos',
      name: 'pedidos',
      component: Pedidos
    },
    {
      path: '/acessos',
      name: 'acesso',
      component: Acessos
    }    
    //,
    // {
    //   path: '/busca/:params/:pagina/',
    //   name: 'busca',
    //   component: Busca
    // },
  ]
})